<div class="content__wrapper">
  @if (showSidebar) {
    <app-nav-menu
      [env]="environment"
      [firstName]="userLite?.firstName || ''"
      [lastName]="userLite?.lastName || ''"
      [isLoggedIn]="isLoggedIn"
      [userToken]="userToken"
      appTitle="Sierra Finance"
      (logout)="onLogout()"
      [menuItems]="menuItems"
      [sites]="sites"
      [selectedSiteId]="selectedSiteId"
      (siteChanged)="onSiteChanged($event)"
    />
  }
  <div class="cs-shell">
    @if (showSidebar) {
      <csl-main-header />
    }
    <router-outlet></router-outlet>
  </div>

  <!-- Way into the guide (#4894) from anywhere in the app. Shown on the same condition as the sidebar, so
       it never appears over the login screen. -->
  @if (showSidebar) {
    <p-button
      class="info-fab"
      icon="pi pi-info-circle"
      [rounded]="true"
      [raised]="true"
      [ariaLabel]="'Info' | translateWF: 'Info'"
      [pTooltip]="'Info_Tooltip' | translateWF: 'How the finance flows work'"
      tooltipPosition="left"
      (click)="goToInfo()"
    />
  }

  <p-dialog key="ct" />
  <p-toast position="bottom-right" key="main" />
</div>
<csl-environment-indicator [envType]="environment" />
